import qs from "qs";

import { useLocation } from "react-router-dom";

const useQuery = ()=>{
  const location = useLocation();
  const queryObj = qs.parse(location.search.replace('?',''));
  return queryObj;
}

export default useQuery;